import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import { TenantRole } from "../../../@types/graphql"
import InviteConfirm from "./InviteConfirm"
import InviteForm from "./InviteForm"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

enum InviteAdminStep {
  Form,
  Confirm,
  Error,
}

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const InviteAdminModal = ({ onClose }: { onClose: () => void }) => {
  const [step, setStep] = useState<InviteAdminStep>(InviteAdminStep.Form)
  const [data, setData] = useState<{
    email: string
    role: TenantRole
    error: string
  }>({
    email: "",
    role: TenantRole.Admin,
    error: "",
  })

  return (
    <Overlay onClick={() => onClose()}>
      <ModalCard onClose={onClose}>
        {step === InviteAdminStep.Form && (
          <InviteForm
            onSubmit={(email, role) => {
              setData((prev) => ({ ...prev, email, role }))
              setStep(InviteAdminStep.Confirm)
            }}
          />
        )}
        {step === InviteAdminStep.Confirm && (
          <InviteConfirm
            email={data.email}
            role={data.role}
            onCancel={() => setStep(InviteAdminStep.Form)}
            onError={(error) => {
              setData((prev) => ({ ...prev, error }))
              setStep(InviteAdminStep.Error)
            }}
            onSuccess={() => onClose()}
          />
        )}
        {step === InviteAdminStep.Error && `API Error: ${data.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default InviteAdminModal
